import { ApiService } from 'src/app/services/api.service';
import { LoadingService } from 'src/app/services/loading.service';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';

@Component({
  selector: 'app-help',
  templateUrl: './help.page.html',
  styleUrls: ['./help.page.scss'],
})
export class HelpPage implements OnInit {
  comments: string;
  form = {
    type: 'service',
    comments: null,
    business_id: null,
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private alertCtrl: AlertController,
    private apiService: ApiService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.form.type = this.activatedRoute.snapshot.paramMap.get('type');
    this.form.business_id = this.activatedRoute.snapshot.paramMap.get('id');
  }

  updateComments(event) {
    this.form.comments = event.target.value;
  }

  send() {
    this.loadingService.present();
    this.apiService
      .postData('ticket', this.form)
      .then((res) => {
        if (res.success) {
          this.simpleAlert('Enviado', 'Ticket abierto correctamente. Pronto será contactado.', true);
        } else {
          this.simpleAlert('Ooops!', 'Hubo un problema con su solicitud, por favor intente nuevamente.', true);
        }
      })
      .finally(() => {
        this.loadingService.dismiss();
      });
  }

  async simpleAlert(title, message, closeAfterClick = false) {
    const alert = await this.alertCtrl.create({
      header: title,
      message,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            if (closeAfterClick) {
              this.router.navigate(['/tecservice/home/business/' + this.form.business_id + '/']);
            }
          },
        },
      ],
    });
    alert.present();
  }
}
